import axios from "axios";
import router from '../router'
import {
	Message
} from 'element-ui'
import {
	Axios
} from "axios";

const getToken = () => {
	return localStorage.getItem("access_token")
}

const _getOptions = (url, data) => {
	return {
		method: 'post',
		url: url,
		// headers: {
		// 	'Content-Type': 'application/json',
		// },
		headers: {},
		timeout: 10000,
		data: data
	}
}

export const myRequest = async (url, data) => {
	try {
		const options = _getOptions(url, data);
		options.headers.Authorization = 'Bearer ' + getToken();
		return await _post(options);
	} catch (e) {
		var errData = {
			code: 0,
			message: "网络连接超时",
		}
		return errData;
		//TODO handle the exception
	}
}



const _post = async (options) => {
	try {
		let result = await axios(options);
		let data = result.data;
		//console.log("接口返回值:" + JSON.stringify(data));
		if (result.status != 200) {
			if (result.status == 415) {
				Message({
					message: "参数错误",
					type: 'error'
				});
			}
		} else {
			if (data.code == 415) {
				Message({
					message: "参数错误",
					type: 'error'
				});
			}

			//未登录
			if (data.code == 99) {
				router.push('/login');
			}
			//统一处理失败
			if (data.code == 0) {
				//const content = `业务请求失败，原因：${data.message}`;
				const content = `${data.message}`;
				Message({
					message: content,
					type: 'error'
				});
			}
		}

		return data;
	} catch (error) {
		if (error.response.status == 401) {
			Message({
				message: "登录失效，请重新登录",
				type: 'error'
			})

			localStorage.clear();
			router.push('/login');
			var errData = {
				code: 0,
				message: "网络连接超时",
			}
			return errData;
		} else {
			Message({
				message: "请求失败，网络连接超时",
				type: 'error'
			})
			var errData = {
				code: 0,
				message: "网络连接超时",
			}
			return errData;
		}
	}
}